import axios from 'axios'
import dayjs from 'dayjs'
import { useContext, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { CongratulatoryCardContext } from 'src/consumer/context/CongraulatoryCardContext'
import { InformationContext } from 'src/consumer/context/InformationContext'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { getData } from 'src/consumer/services/profileService'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import {
  ALL_SUPPORTED_ROLES_FOR_FLOW_SELECTION,
  getAllRolesInBoolean,
  getUserRoles,
} from 'src/mentor/layout/utils'
import { SetupContext } from '../../context/SetupContext'
import { getTabOrder, getTabsListMap } from '../../helpers/tabDataHelper'
import { apiURL } from '../../services/index'
import { RedirectStrip, RedirectStripButton } from '../BlockerScreens/RedirectStyles'
import CongratulatoryCard from '../CongratulatoryScreen'
import CoursePlayer from '../CourseCards/CoursePlayer'
import { GenericInformationModal } from '../GenericInformationModal'
import GlobalNav from '../GlobalHeader/GlobalNav'
import Journal from '../Journal'
import { LoadingSpinner } from '../Loaders'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import { FlowSelectionComponent } from './FlowSelectionModern'
import { StyledComsumerContainer } from './ConsumerHomepageStyle'

const ConsumerHomepage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { state } = location
  const isRootPath = location.pathname === '/' || location.pathname === ''
  const showPrewallOnHome = state?.showPrewallOnHome

  const prewallData = {
    content_play: {
      id: 'content_play',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },

    journal_play: {
      id: 'journal_play',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },

    free_trial_box_tap: {
      id: 'free_trial_box_tap',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },

    upgrade_btn: {
      id: 'upgrade_btn',
      toggleFunction: () => {
        setIsCommonPrewallOpen((prev) => !prev)
      },
    },
  }

  const { unSecureSetupLoading, unSecureSetupData, unSecureSetupError } =
    useContext(UnsecureSetupContext)
  const { setupLoading, setupData, setupError } = useContext(SetupContext)

  const [pageState, setPageState] = useState()

  useEffect(() => {
    if (Boolean(setupData)) {
      localStorage.setItem('metaMoods', JSON.stringify(setupData?.metaMoods))
    }
  }, [setupData])

  const { profileData, setProfileData } = useContext(ProfileContext)
  const { informationModalData, setInformationModalData } = useContext(InformationContext)

  const [playerData, setPlayerData] = useState({
    showPIP: false,
    showLeavingEarly: false,
    showPlayer: false,
    selectedCard: '',
    showCompletionFeedback: false,
    source: '',
    id: '',
    otherData: {},
  })
  const [journalData, setJournalData] = useState({
    showJournal: false,
    callSource: '',
    data: '',
    pageState: '',
    subscription: '',
  })
  const [congratulatoryCardData, setCongratulatoryCardData] = useState({
    showCard: false,
    data: {},
  })

  const [isPreAndPaywallOpen, setIsPreAndPaywallOpen] = useState(showPrewallOnHome || false)
  const [isCommonPrewallOpen, setIsCommonPrewallOpen] = useState(false)

  const [timeSlotsData, setTimeSlotsData] = useState({})
  const [userFavoriteData, setUserFavoriteData] = useState({})
  const [completionData, setCompletionData] = useState([])
  const [commonPrewallData, setCommonPrewallData] = useState('')
  const [bookedSlotsDataPageOne, setBookedSlotsDataPageOne] = useState([])
  const [userScoreData, setUserScoreData] = useState([])
  const [oneOnOneMentorsData, setOneOnOneMentorsData] = useState([])

  const { tileId } = useParams()
  const defaultTab = getAllRolesInBoolean().isPatient
    ? 'patient-home'
    : getTabOrder(setupData)?.preselectedTab

  const selectedTileId = tileId || defaultTab

  useEffect(() => {
    ;(async () => {
      const response = await getData('/api/secure/user/booked-slots')
      if (response?.status === 200) {
        setBookedSlotsDataPageOne(response?.data)
      }
    })()
    ;(async () => {
      const response = await getData('/api/secure/user/points-profile')
      if (response?.status === 200) {
        setUserScoreData(response?.data)
      }
    })()
    ;(async () => {
      const response = await getData('/api/external/mentor/1on1/list')
      if (response?.status === 200) {
        setOneOnOneMentorsData(response?.data)
      }
    })()
  }, [])

  useEffect(() => {
    if (
      profileData?.subscriptionTypeId === 'subscription_free' &&
      playerData?.selectedCard !== '' &&
      playerData?.selectedCard?.course?.subscription?.id !== 'subscription_free'
    ) {
      setPlayerData({
        showPIP: false,
        showLeavingEarly: false,
        showPlayer: false,
        selectedCard: '',
        showCompletionFeedback: false,
        source: '',
        id: '',
      })
      setCommonPrewallData(prewallData?.['content_play'])
      setIsCommonPrewallOpen(true)
    }
  }, [playerData])

  useEffect(() => {
    if (
      profileData?.subscriptionTypeId === 'subscription_free' &&
      journalData?.showJournal === true &&
      journalData?.pageState === 'new_journal' &&
      journalData?.subscription !== 'subscription_free'
    ) {
      setJournalData({
        showJournal: false,
        callSource: '',
        data: '',
        pageState: '',
        subscription: '',
      })
      setCommonPrewallData(prewallData?.['journal_play'])
      setIsCommonPrewallOpen(true)
    }
  }, [journalData])

  async function setupTimeSlots() {
    const fetchTimeSlots = async () => {
      let data = await axios.get(`${apiURL}/api/timeslots`)
      return data
    }
    let timeSlotResponse = await fetchTimeSlots()
    if (timeSlotResponse.status === 200) {
      setTimeSlotsData(timeSlotResponse?.data)
    } else {
      console.log('error getting time slots')
    }
  }

  async function setupUserFavorites() {
    const fetchUserFavorites = async () => {
      let data = await getData('/api/secure/user/favorites')
      return data
    }
    let userFavoriteResponse = await fetchUserFavorites()
    if (userFavoriteResponse.status === 200) {
      setUserFavoriteData(userFavoriteResponse?.data)
    } else {
      console.log('error getting time slots')
    }
  }

  async function updateDailyPlayProgress() {
    const response = await getDataWithoutParams(
      `/api/secure/user/daily-play-streaks?zoneOffset=${encodeURIComponent(getTimezoneOffset())}`,
    )
    if (response.status === 200) {
      setCompletionData(response?.data)
    }
  }

  async function updateUserScoreData() {
    const response = await getData('/api/secure/user/points-profile')
    if (response?.status === 200) {
      setUserScoreData(response?.data)
    }
  }

  useEffect(() => {
    setupTimeSlots()
    updateDailyPlayProgress()
  }, []) //setting time slots

  useEffect(() => {
    setupUserFavorites()
  }, []) // setting user favorites

  useEffect(() => {
    if (localStorage.getItem('authorities')) {
      const userRoles = getUserRoles()
      const hasSupportRoles =
        getAllRolesInBoolean().isL1TherapySupport ||
        getAllRolesInBoolean().isL2TherapySupport ||
        getAllRolesInBoolean().isL3TherapySupport ||
        getAllRolesInBoolean().isClinicRosterManager ||
        getAllRolesInBoolean().isClinicSuccessManager
      const hasOtherRoles = userRoles.filter((item) =>
        ALL_SUPPORTED_ROLES_FOR_FLOW_SELECTION.includes(item),
      )?.length > 0

      // Check if user explicitly chose consumer portal from footer/flow selection
      const explicitlyChoseConsumer = Boolean(sessionStorage.getItem('explicitlyChoseConsumerPortal'))
      
      // If user has ONLY support roles (no other roles), auto-redirect to support portal
      // BUT skip this if user explicitly chose consumer portal
      if (
        hasSupportRoles &&
        !hasOtherRoles &&
        !Boolean(sessionStorage.getItem('portalAutoNavigatedToAtFlow')) &&
        !explicitlyChoseConsumer
      ) {
        handleChoosingSupportSide()
        sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
        return
      }

      // Check if user has non-consumer portal roles
      const availableRoles = getAllRolesInBoolean()
      const hasNonConsumerRoles =
        availableRoles.isDoctor ||
        availableRoles.isTeacher ||
        availableRoles.isClinicOwner ||
        availableRoles.isClinicManager ||
        availableRoles.isClinicProspect ||
        availableRoles.isClinicAssistant ||
        availableRoles.isAumhumScreen ||
        availableRoles.isBusinessCustomer ||
        availableRoles.isBusinessProspect ||
        hasSupportRoles
      
      // Special handling for Clinic Assistant and Kiosk roles
      const hasClinicAssistantOnly = availableRoles.isClinicAssistant && !availableRoles.isAumhumScreen
      const hasAumhumScreenOnly = availableRoles.isAumhumScreen && !availableRoles.isClinicAssistant
      const hasBothCARoles = availableRoles.isClinicAssistant && availableRoles.isAumhumScreen

      // Check if user has multiple roles (including support roles)
      const rolesInFlowSelection = userRoles.filter((item) =>
        ALL_SUPPORTED_ROLES_FOR_FLOW_SELECTION.includes(item),
      )?.length
      const totalRoleCount = rolesInFlowSelection + (hasSupportRoles ? 1 : 0)

      // Special handling for Clinic Assistant and Kiosk roles - they should default to their home pages
      // instead of showing flow selection if they have only one of these roles
      // These roles take priority over explicit consumer portal choice if user has stored configs
      // Always redirect from root path if user has these roles, regardless of portalAutoNavigatedToAtFlow flag
      if (hasClinicAssistantOnly) {
        // User has only ROLE_CLINIC_ASSISTANT - default to /ca-home
        // Clear explicitlyChoseConsumer flag for these roles as they should always default to their portal
        sessionStorage.removeItem('explicitlyChoseConsumerPortal')
        // Always redirect from root path, or if flag is not set
        if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
          handleChoosingCAUserSide()
          sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
        }
        return
      }
      
      if (hasAumhumScreenOnly) {
        // User has only ROLE_AUMHUM_SCREEN - default to /kiosk
        // Clear explicitlyChoseConsumer flag for these roles as they should always default to their portal
        sessionStorage.removeItem('explicitlyChoseConsumerPortal')
        // Always redirect from root path, or if flag is not set
        if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
          handleChoosingKioskUserSide()
          sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
        }
        return
      }
      
      if (hasBothCARoles) {
        // User has both roles - determine default based on lastChosenFlow (user preference)
        // or stored flow config as fallback
        // Clear explicitlyChoseConsumer flag for these roles as they should always default to their portal
        sessionStorage.removeItem('explicitlyChoseConsumerPortal')
        const lastChosenFlow = localStorage.getItem('lastChosenFlow')
        const kioskConfigStr = localStorage.getItem('kiosk-config')
        const roleCaConfigStr = localStorage.getItem('ROLE_CA_CONFIG')
        const kioskConfig = kioskConfigStr ? JSON.parse(kioskConfigStr) : null
        const roleCaConfig = roleCaConfigStr ? JSON.parse(roleCaConfigStr) : null
        
        // Priority 1: Check lastChosenFlow (user's last preference) - respects user's choice
        // This fixes the issue where kiosk-config always wins because it persists through logout
        // If lastChosenFlow is set, redirect to that portal even if config is missing
        // (the portal landing page will handle creating/selecting the config)
        if (lastChosenFlow === 'kiosk') {
          // Always redirect from root path, or if flag is not set
          if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
            handleChoosingKioskUserSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          }
          return
        }
        
        if (lastChosenFlow === 'clinic-assistant') {
          // Always redirect from root path, or if flag is not set
          if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
            handleChoosingCAUserSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          }
          return
        }
        
        // Priority 2: Check kiosk-config (if no lastChosenFlow preference or invalid)
        if (kioskConfig?.FLOW_ID) {
          // Always redirect from root path, or if flag is not set
          if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
            handleChoosingKioskUserSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          }
          return
        }
        
        // Priority 3: Check ROLE_CA_CONFIG
        if (roleCaConfig?.FLOW_ID) {
          // Always redirect from root path, or if flag is not set
          if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
            handleChoosingCAUserSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          }
          return
        }
        
        // Priority 4: If neither config has a flow, show role selection page
        // Don't set portalAutoNavigatedToAtFlow flag so user can choose
        if (isRootPath || !sessionStorage.getItem('portalAutoNavigatedToAtFlow')) {
          setPageState('flowSelection')
        }
        return
      }

      // If user has non-consumer portal roles, never redirect to consumer portal
      // UNLESS user explicitly chose consumer portal from footer/flow selection
      if (hasNonConsumerRoles && !explicitlyChoseConsumer) {
        if (totalRoleCount > 1) {
          // User has multiple roles - always show flow selection
          if (!sessionStorage.getItem('chosenSomeFlowInThisSession')) {
            setPageState('flowSelection')
          } else {
            // User already chose a flow in this session, respect that choice
            // But don't redirect to consumer if they have other portal roles
            const lastChosenFlow = localStorage.getItem('lastChosenFlow')
            if (lastChosenFlow && lastChosenFlow !== 'consumer') {
              // Redirect based on last chosen flow (non-consumer)
              if (lastChosenFlow === 'mentor') {
                handleChoosingMentorSide()
              } else if (lastChosenFlow === 'clinic') {
                navigate('/clinic-home')
              } else if (lastChosenFlow === 'clinic-assistant') {
                handleChoosingCAUserSide()
              } else if (lastChosenFlow === 'kiosk') {
                handleChoosingKioskUserSide()
              } else if (lastChosenFlow === 'support') {
                handleChoosingSupportSide()
              } else if (lastChosenFlow === 'business') {
                navigate('/workplace')
              } else {
                // Fallback: show flow selection
                setPageState('flowSelection')
              }
            } else {
              // No valid last chosen flow or it was consumer - show flow selection
              setPageState('flowSelection')
            }
          }
        } else {
          // User has only one non-consumer role - auto-redirect to that portal
          // UNLESS user explicitly chose consumer portal
          if (explicitlyChoseConsumer) {
            // User explicitly chose consumer portal, respect that choice
            handleChoosingEndUserSide()
          } else if (hasSupportRoles) {
            handleChoosingSupportSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          } else if (availableRoles.isDoctor || availableRoles.isTeacher) {
            handleChoosingMentorSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          } else if (availableRoles.isClinicAssistant) {
            handleChoosingCAUserSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          } else if (availableRoles.isAumhumScreen) {
            handleChoosingKioskUserSide()
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          } else if (
            availableRoles.isClinicOwner ||
            availableRoles.isClinicManager ||
            availableRoles.isClinicProspect
          ) {
            navigate('/clinic-home')
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          } else if (
            availableRoles.isBusinessCustomer ||
            availableRoles.isBusinessProspect
          ) {
            navigate('/workplace')
            sessionStorage.setItem('portalAutoNavigatedToAtFlow', true)
          }
        }
      } else {
        // User has only consumer role - redirect to consumer portal
        handleChoosingEndUserSide()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileData, setupData])

  function handleChoosingEndUserSide() {
    // Set flag to indicate user explicitly chose consumer portal
    sessionStorage.setItem('explicitlyChoseConsumerPortal', 'true')
    setPageState('consumer')
    if (profileData && !profileData?.info?.USER_ON_BOARD) {
      if (getAllRolesInBoolean().isPatient) {
        navigate('/tile/patient-home', {})
      } else {
        navigate('/onboarding', {})
      }
    } else {
      if (getAllRolesInBoolean().isPatient) {
        navigate('/tile/patient-home', {})
      } else if (selectedTileId && canRedirectToTiles(window.location.pathname)) {
        navigate(`/tile/${selectedTileId}`)
      }
    }
  }

  function handleChoosingCAUserSide() {
    sessionStorage.setItem('chosenSomeFlowInThisSession', true)
    localStorage.setItem('lastChosenFlow', 'clinic-assistant')
    navigate('/ca-home')
  }

  function handleChoosingKioskUserSide() {
    sessionStorage.setItem('chosenSomeFlowInThisSession', true)
    localStorage.setItem('lastChosenFlow', 'kiosk')
    navigate('/kiosk')
  }

  function handleChoosingMentorSide() {
    sessionStorage.setItem('chosenSomeFlowInThisSession', true)
    // Check roles to determine default route
    const roles = getAllRolesInBoolean()
    const hasClinicAccessRole = roles.isDoctor || roles.isTherapist || roles.isScreener
    
    if (hasClinicAccessRole) {
      navigate('/mentor-home/my-clinic-associations')
    } else {
      navigate('/mentor-home/preferences-and-settings')
    }
  }

  function handleChoosingSupportSide() {
    sessionStorage.setItem('chosenSomeFlowInThisSession', true)
    localStorage.setItem('lastChosenFlow', 'support')
    navigate('/support-home')
  }

  if (unSecureSetupLoading || setupLoading) {
    return <LoadingSpinner />
  }

  function openPrewallFunction(prewallId) {
    setCommonPrewallData(prewallData?.[prewallId])
    setIsCommonPrewallOpen(true)
  }

  console.log(tileId)
  console.log(defaultTab)

  return (
    <CongratulatoryCardContext.Provider
      value={{ congratulatoryCardData, setCongratulatoryCardData }}
    >
      <PlayerContext.Provider value={{ playerData, setPlayerData }}>
        <JournalContext.Provider value={{ journalData, setJournalData }}>
          {/* prewalls :   */}

          <PrewallAndPaywall
            id="onboarding"
            secureData={setupData}
            wallIsOpen={isPreAndPaywallOpen}
            toggleWall={() => {
              setIsPreAndPaywallOpen((prev) => !prev)
              window.history.replaceState({}, '')
            }}
          />

          <PrewallAndPaywall
            id={commonPrewallData?.id}
            secureData={setupData}
            wallIsOpen={isCommonPrewallOpen}
            toggleWall={commonPrewallData?.toggleFunction}
          />

          {/* context components :  */}

          {playerData?.showPlayer && <CoursePlayer userFavoriteData={userFavoriteData} />}
          {journalData?.showJournal && <Journal />}
          {congratulatoryCardData?.showCard && <CongratulatoryCard />}
          {informationModalData?.showModal && <GenericInformationModal />}

          {/* UI :  */}

          {(pageState === 'flowSelection' || window.location.search.includes('showFlowSelection=true')) && (
            <FlowSelectionComponent
              showNormalUserView={() => {
                handleChoosingEndUserSide()
              }}
            />
          )}

          {pageState === 'consumer' && (
            <StyledComsumerContainer lightBg={window.location.pathname === '/tile/patient-home'}>
              {unSecureSetupData?.clientType === 'mobileBrowser' &&
                showRedirectStrip(window.location.pathname) && (
                  <RedirectStrip>
                    Upgrade to smarter AUMHUM
                    <RedirectStripButton
                      onClick={() => (window.location.href = 'https://aumhum.page.link/app')}
                    >
                      OPEN
                    </RedirectStripButton>
                  </RedirectStrip>
                )}

              {showGlobalNav(window.location.pathname) && (
                <GlobalNav
                  tabOrder={getTabOrder(setupData)}
                  tabsListMap={getTabsListMap(setupData)}
                  activeTile={selectedTileId}
                  unSecureSetupData={unSecureSetupData}
                  isMobile={unSecureSetupData?.clientType === 'mobileBrowser'}
                  openPrewallFunction={() => openPrewallFunction('free_trial_box_tap')}
                  bookedSlotsDataPageOne={bookedSlotsDataPageOne}
                  userScoreData={userScoreData}
                />
              )}

              <Outlet
                context={{
                  selectedTileId,
                  timeSlotsData,
                  completionData,
                  openPrewallFunction,
                  userFavoriteData,
                  bookedSlotsDataPageOne,
                  updateUserScoreData,
                  oneOnOneMentorsData,
                }}
              />
            </StyledComsumerContainer>
          )}
        </JournalContext.Provider>
      </PlayerContext.Provider>
    </CongratulatoryCardContext.Provider>
  )
}

function showGlobalNav(locationPathName) {
  const noNavPages = [
    '/profile',
    '/leaderboard',
    '/my-live-sessions',
    '/live',
    '/my-plan',
    '/plan',
    '/my-activity',
  ]

  for (let page of noNavPages) {
    if (locationPathName.startsWith(page)) {
      return false
    }
  }

  return true
}

export function showRedirectStrip(locationPathName) {
  const noRedirectStripPages = [
    '/my-live-sessions',
    '/live',
    '/my-plan',
    '/my-activity',
    '/my-plan/create',
    '/tile/patient-home',
  ]
  for (let page of noRedirectStripPages) {
    if (locationPathName.startsWith(page)) {
      return false
    }
  }
  return true
}

function canRedirectToTiles(locationPathName) {
  const noRedirectPages = [
    '/profile',
    '/my-live-sessions',
    '/my-plan',
    '/my-activity',
    '/leaderboard',
    '/redeem',
    '/tile/practice',
    '/tile/patient-home',
  ]
  for (let page of noRedirectPages) {
    if (locationPathName.startsWith(page)) {
      return false
    }
  }
  return true
}

export default ConsumerHomepage
